import React from 'react';
import styled from 'styled-components';
import { useLang } from '../../context/LangContext';
import { Language } from '../../i18n/translations';

const Wrapper = styled.div`
  position: fixed;
  top: 16px;
  right: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 3px;
  z-index: 900;

  @media print {
    display: none !important;
  }
`;

const LangButton = styled.button<{ $active: boolean }>`
  display: flex;
  align-items: center;
  padding: 2px 4px;
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  border: 1px solid ${({ $active, theme }) =>
    $active ? theme.colors.primary : theme.colors.border};
  background: ${({ $active, theme }) =>
    $active ? theme.colors.primary : 'rgba(255,255,255,0.15)'};
  color: ${({ $active, theme }) =>
    $active ? '#fff' : theme.colors.textLight};
  font-size: 0.72rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  line-height: 1;
  backdrop-filter: blur(4px);

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
    color: ${({ $active, theme }) => ($active ? '#fff' : theme.colors.primary)};
  }
`;

const Flag = styled.span`
  font-size: 0.95rem;
  line-height: 1;
`;

const LANGS: { code: Language; flag: string; label: string }[] = [
  { code: 'ru', flag: '🇷🇺', label: 'RU' },
  { code: 'en', flag: '🇬🇧', label: 'EN' },
];

export const LangToggle: React.FC = () => {
  const { lang, setLang } = useLang();

  return (
    <Wrapper>
      {LANGS.map(({ code, flag, label }) => (
        <LangButton key={code} $active={lang === code} onClick={() => setLang(code)} title={label} aria-label={label}>
          <Flag>{flag}</Flag>
        </LangButton>
      ))}
    </Wrapper>
  );
};
